import { __awaiter, __generator } from "tslib";
import { NetworkService } from '../Services/NetworkService';
var ComplaintSupportRepo = /** @class */ (function () {
    function ComplaintSupportRepo() {
    }
    Object.defineProperty(ComplaintSupportRepo, "getCustomerList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store) {
            return __awaiter(this, void 0, void 0, function () {
                var customers;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, 'customer-list', 'GET')];
                        case 1:
                            customers = _a.sent();
                            return [2 /*return*/, customers];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintSupportRepo, "getBrandList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store) {
            return __awaiter(this, void 0, void 0, function () {
                var brands;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, 'product-list', 'GET')];
                        case 1:
                            brands = _a.sent();
                            return [2 /*return*/, brands];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintSupportRepo, "getPackagingList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store) {
            return __awaiter(this, void 0, void 0, function () {
                var packaging;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, 'packaging-list', 'GET')];
                        case 1:
                            packaging = _a.sent();
                            return [2 /*return*/, packaging];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintSupportRepo, "getDischargeList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store) {
            return __awaiter(this, void 0, void 0, function () {
                var discharge;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, 'discharge-port-list', 'GET')];
                        case 1:
                            discharge = _a.sent();
                            return [2 /*return*/, discharge];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintSupportRepo, "getModelDeliveryList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store) {
            return __awaiter(this, void 0, void 0, function () {
                var modelDelivery;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, 'model-of-delivery-list', 'GET')];
                        case 1:
                            modelDelivery = _a.sent();
                            return [2 /*return*/, modelDelivery];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintSupportRepo, "getConformanceList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store) {
            return __awaiter(this, void 0, void 0, function () {
                var conformance;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, 'conformance-type-list', 'GET')];
                        case 1:
                            conformance = _a.sent();
                            return [2 /*return*/, conformance];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintSupportRepo, "getComplaintMediaList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store) {
            return __awaiter(this, void 0, void 0, function () {
                var media;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, 'complaint-media-list', 'GET')];
                        case 1:
                            media = _a.sent();
                            return [2 /*return*/, media];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintSupportRepo, "getEnclosedList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store) {
            return __awaiter(this, void 0, void 0, function () {
                var enclosed;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, 'enclosed-list', 'GET')];
                        case 1:
                            enclosed = _a.sent();
                            return [2 /*return*/, enclosed];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintSupportRepo, "getQuestionList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store, conformanceId) {
            return __awaiter(this, void 0, void 0, function () {
                var questions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, "questions-list-by-conformance-type/" + conformanceId, 'GET')];
                        case 1:
                            questions = _a.sent();
                            return [2 /*return*/, questions];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintSupportRepo, "getSalesList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store) {
            return __awaiter(this, void 0, void 0, function () {
                var sales;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, 'member-management-by-role/lookup?role=sales', 'GET')];
                        case 1:
                            sales = _a.sent();
                            return [2 /*return*/, sales];
                    }
                });
            });
        }
    });
    return ComplaintSupportRepo;
}());
export { ComplaintSupportRepo };
//# sourceMappingURL=data:application/json;base64,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